// previews: https://leaflet-extras.github.io/leaflet-providers/preview/

export interface ITileLayer {
  url: string;
  maxZoom: number;
  name: string;
  pixiScale: number;
  subdomains?: string[];
}

export const tileLayersMap: ITileLayer[] = [
  {
    url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
    maxZoom: 30,
    name: 'Claro',
    pixiScale: 1,
  },
  {
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    maxZoom: 19,
    name: 'Satelite 1',
    pixiScale: 0.03,
  },
  {
    url: 'https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
    maxZoom: 22,
    name: 'Satelite 2',
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
    pixiScale: 0.05,
  },
  {
    url: 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
    maxZoom: 22,
    name: 'Detalhado 1',
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
    pixiScale: 0.05,
  },
  {
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    maxZoom: 19,
    name: 'Detalhado 2',
    pixiScale: 0.03,
  },
  {
    url: 'https://{s}.tile.openstreetmap.de/tiles/osmde/{z}/{x}/{y}.png',
    maxZoom: 18,
    name: 'Detalhado 3',
    pixiScale: 0.02,
  },
  {
    url: 'https://{s}.tile.openstreetmap.fr/osmfr/{z}/{x}/{y}.png',
    maxZoom: 20,
    name: 'Detalhado 4',
    pixiScale: 0.05,
  },
  {
    url: 'https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
    maxZoom: 20,
    name: 'Detalhado 5',
    pixiScale: 0.05,
  },
  {
    url: 'https://tiles.wmflabs.org/hikebike/{z}/{x}/{y}.png',
    maxZoom: 20,
    name: 'Detalhado 6',
    pixiScale: 0.05,
  },
  {
    url: 'https://{s}.google.com/vt/lyrs=m@221097413,traffic&x={x}&y={y}&z={z}',
    maxZoom: 22,
    name: 'Tráfego',
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
    pixiScale: 0.05,
  },
  {
    url: 'https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
    maxZoom: 22,
    name: 'Hibrido',
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
    pixiScale: 0.05,
  },
];

export const getUserSavedTileLayer = () => {
  try {
    const urlUserSelectedTileLayer = window.localStorage.getItem('@sgi_leaflet_default-tile-layer');

    return tileLayersMap.find((t) => t.url === urlUserSelectedTileLayer) || tileLayersMap[0];
  } catch (error) {}
};
